import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import history from './history'
import { setConfig } from './actions/config'
import { indexOf } from 'lodash'
import NotificationsSystem from 'reapop'
import theme from './notifications/reapop/reapop-theme-bootstrap'
import { isMobileDevice } from './functions.js'

// global css
import './css/mi-app/bootstrap.css'
import './css/main.css'
import './css/mi-app/style.css'

// structural elements
import LeftSidebar1 from './elements/LeftSidebar1'
import RightSidebar1 from './elements/right-sidebar/Index'
import NavBar from './mi-app/V2_NavBar.js'
import Backdrops from './elements/Backdrops'
import WelcomeMI from './mi-app/modals/WelcomeMI'
import ConferenceMI from './mi-app/modals/ConferenceMI'

// keyboard shortcuts for development
import Shortcuts from './helpers/Shortcuts'

import Routes from './Routes'
import { initializeCustomValidators, getJwt } from './pages/functions'
import { DISABLE_MODAL_PATHS_INCLUDING_ERROR_PATH , Timeout } from './constants'
import BotAssistant from './mi-app/digitalAssistant/BotAssistant'
import BotAssistantMobile from './mi-app/digitalAssistant/BotAssistantMobile'
import StaticConfig from './mi-app/StaticConfig'
import { eraseCookieFromAllPaths, getCookie, isCookiePresent } from './helpers/CookieHandler'
import './fingerprint'
import PatientDisclosureModal from './mi-app/modals/PatientDisclosureModal'
import { config } from './json/config.json'
import ChatConfig from './mi-app/AMI_assistant/ChatConfig.js'

class App extends Component {
  constructor() {
    super()
    this.setLayout = this.setLayout.bind(this)

    history.listen(({ pathname }, action) => {
      this.setLayout(pathname)
    })
    const isLogin = sessionStorage.getItem('loginBySSO') != null

    const isWelcomeModalRequired = !(DISABLE_MODAL_PATHS_INCLUDING_ERROR_PATH.includes(window.location.pathname) || isLogin === true)

    this.state = {
      showWelcomeModal: isWelcomeModalRequired,
      showPatientDisclosureModal: false
    }
    const isConferenceModelRequired = (DISABLE_MODAL_PATHS_INCLUDING_ERROR_PATH.includes(window.location.pathname))
    if (isConferenceModelRequired) {
      this.state = {
        showConferenceModal: isConferenceModelRequired
      }
    }

    // Store a reference to the digital assistant. This allows ProductDetails.js to open
    // the assistant by calling BotAssistant.openFromExternalComponent()
    StaticConfig.assistantRef = React.createRef()
	//to automatically logout an oAuth SSO (Aus-HCP) user after 4 hrs
	setInterval(function () { 
    	
                    
    	if(document.cookie.indexOf('id_token') > -1){
    		document.cookie = `OauthAuthenticated=true; max-age=86400`;
                    	
                    }
                    	
               },30)
	var uiURL = config[window.location.hostname].baseUIURL
	let timeout = Timeout
    setInterval(function () { 
                   
                    if(getCookie("OauthAuthenticated")=="true"){
                    	document.cookie=`Timeout=${timeout}`
                    	
                    	timeout=timeout-30000
                    	if(timeout < 360000){
                    		eraseCookieFromAllPaths("OauthAuthenticated")
                    		eraseCookieFromAllPaths("Timeout")
                    		window.location.replace(uiURL)
                    	}
                    	
                    }                        

                },300000 )
  }

  componentWillMount() {
    this.setLayout(this.props.pathname)

    // Add custom validators to approveJs
    initializeCustomValidators('fffffff')
  }

  componentDidMount() {
    setInterval(() => {
      if (window.location.pathname !== '/scibooth' &&
        (!this.props.referenceData || this.props.referenceData.referenceData.UserType !== 'ABBVIE_EMPLOYEE')) return
      const token = getJwt()
      if (!token || token === '') {
        if (window.location.pathname === '/scibooth') {
          window.location.reload()
        } else {
          window.location.replace('/')
        }
      }
    }, 15000)
  }

  componentDidUpdate() {
    window.scrollTo(0, 0)
  }

  // Currently, this always results in a layout of top-navigation-1 (the starting layout)
  setLayout(url) {
    const emptyView1 = [
      '/pages/error-page'
    ]

    const isEmptyView = indexOf(emptyView1, url) !== -1
    const currentLayout = this.props.config.layout
    if (isEmptyView && currentLayout !== 'empty-view-1') {
      this.props.setConfig('layout', 'empty-view-1')
    } else if (!isEmptyView) {
      if (currentLayout === 'empty-view-1') {
        this.props.setConfig('layout', 'default-sidebar-1')
      } else {
        this.props.setConfig('layout', currentLayout)
      }
    }
  }

  render() {
    const { layout, background, navbar, logo, leftSidebar, topNavigation, collapsed } = this.props.config
    const isEmptyView = layout === 'empty-view-1'
    const showNavBar = !(DISABLE_MODAL_PATHS_INCLUDING_ERROR_PATH.includes(window.location.pathname))

    return (
      <div>
        <ConnectedRouter history={history}>
          <div
            data-layout={layout}
            data-background={background}
            data-navbar={navbar}
            data-logo={logo}
            data-left-sidebar={leftSidebar}
            data-top-navigation={topNavigation}
            data-collapsed={collapsed}
          >
            <NotificationsSystem theme={theme} />
            <Shortcuts />
            <Backdrops />
            <RightSidebar1 />
            <NavBar showNavBar={showNavBar} />
            <div className={isEmptyView ? '' : 'container-fluid p-0'}>
              <div className={isEmptyView ? '' : 'row'}>
                <LeftSidebar1 />
                <div className={`col main nav-height-${this.props.navExpandBreakpoint}`}>
                  <Routes />
                </div>
              </div>
            </div>
            {/* {isMobileDevice() ? <BotAssistantMobile ref={StaticConfig.assistantRef} /> : <BotAssistant ref={StaticConfig.assistantRef} />} */}
            <ChatConfig ref={StaticConfig.assistantRef} />
          </div>
        </ConnectedRouter>

        <div>
          <WelcomeMI
            isOpen={this.state.showWelcomeModal}
            toggle={() => this.setState({ showWelcomeModal: false })}
            togglePatientDisclosureModal={() => this.setState({ showPatientDisclosureModal: true })}
          />
          <PatientDisclosureModal
            isModalOpen={this.state.showPatientDisclosureModal}
            toggle={() => this.setState({ showPatientDisclosureModal: false })}
          />
          {
            this.state.showConferenceModal && window.location.pathname !== '/country-not-available'
              ? (
                <ConferenceMI
                  onSubmit={null /* this._onConferenceSubmit */}
                  toggle={() => this.setState({ showConferenceModal: false })}
                />) : null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ config, referenceData, navigation }, ownProps) => ({
  config,
  referenceData: referenceData.filter(({ type }) => type === 'REF_DATA')[0],
  navExpandBreakpoint: navigation[1].expandBreakpoint
})
const mapDispatchToProps = dispatch => ({
  setConfig: (key, value) => dispatch(setConfig(key, value))
})
export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/App.js